module.exports = __webpack_public_path__ + "media/images/emblems/Thoerigen-coat_of_arms-5bdba2a2d86a3e6be7d6935fbb4ac0af.svg";